/**
 * Small Javascript class for the Denhaag Button animation (which is denhaag.nl specific #snowflake).
 */
export default class DenhaagButtonAnimation {
    /**
     * Small and simple class
     *
     * @param {string} selector CSS selector to target the button.
     * @param {string} modifier Modifier class to toggle.
     */
    constructor( selector = '.denhaag-button', modifier = 'clicked' ) {
        this.btns = document.querySelectorAll( selector );

        if ( !this.btns ) {
            return;
        }

        this.className = `${ selector.slice( 1 ) }--${ modifier }`;
        this.events();
    }

    events() {
        Array.from( this.btns ).forEach( ( btn ) => {
            // Using `addEventListener` instead of `onclick` due to the GravityForms specific functions.
            btn.addEventListener( 'click', () => btn.classList.add( this.className ) );
            btn.addEventListener( 'mouseleave', () => btn.classList.remove( this.className ) );
        } );
    }
}
